<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-09-05 15:40:59
 * @FilePath: /mrc-ess-fronted/src/Layout/404Page.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-02-24 18:31:04
-->
<template>
  <v-container
    class="
      max-width
      d-flex
      flex-grow-1
      ma-0
      pa-0
      fill-height
      flex-column
      justify-center
      text-center
      align-center align-self-center
    "
    :elevation="0"
    style="min-height: 500px"
    fluid
  >
    <div>
      <svg-icon size="200" iconClass="Error_404" />
      <div class="text-h5 text--secondary">
        {{ $t("message_essweb_system_message_pageNotFoundLabel") }}
      </div>
      <div class="text-body-2 text--secondary mt-4">
        {{ $t("message_essweb_system_message_clickLabel") }}
        <span
          class="primary--text"
          style="text-decoration: underline; cursor: pointer"
          @click="$toPage('/', {}, 'replace')"
          >{{ $t("message_essweb_system_message_hereBtnLabel") }}</span
        >
        {{ $t("message_essweb_system_message_goHomeLabel") }}
      </div>
    </div>
  </v-container>
</template>
<script>
export default {
  name: "Page404",
  data() {
    return {};
  },
  methods: {},
};
</script>
<style scoped>
</style>